import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from '../../constants/app-constants';
import { DataService } from '../../services/data.service';
import { SaeForgotPasswordService } from './sae-forgot-password.service';
import { FwcHero, FwcPreloader, FwcAlert } from '../../../../fwc-lib.js';
import { WcsApiService } from 'src/app/common/services/wcs-api-service';
import { SAEBaseComponent } from 'src/app/common/components/sae-base.component';
import { UserCacheService } from '../../services/user-cache.service';

@Component({
    selector: 'sae-forgot-password',
    templateUrl: './sae-forgot-password.component.html',
    styleUrls: ['./sae-forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SaeForgotPasswordComponent extends SAEBaseComponent implements OnInit {

  @Input() content: any;
  @Output() updateUserCache: EventEmitter<any> = new EventEmitter<any>();
  displaySpinner = false;
  forgotForm!: UntypedFormGroup;
  submitted = false;
  emailValidateError: boolean = false;
  saeUserId: any;
  mfaFactors: any;
  public contents: any;
  forgotPasswordOutput = {
    email: '',
    firstName: '',
    lastName: ''
  };

  constructor(
    public wcsApiService: WcsApiService,
    private formBuilder: UntypedFormBuilder,
    public saeForgotPasswordService: SaeForgotPasswordService,
    public dataService: DataService,
    public router: Router,
    private route: ActivatedRoute, public userCacheService: UserCacheService,
  ) { 
    super(wcsApiService);
    const fwcHero = new FwcHero();
    fwcHero.build();
     const fwcPreloader = new FwcPreloader();
    fwcPreloader.build();
    const fwcAlert = new FwcAlert();
    fwcAlert.build();
  }

  async ngOnInit(): Promise<void> {
    this.forgotForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
     // firstName: ['', Validators.required],
     // lastName: ['', Validators.required]
    });
    await this.loadWCSData('login');
    if (this.wcsdata) {
    this.contents = this.wcsdata;
  }
  }
  get form(): { [p: string]: AbstractControl } { return this.forgotForm.controls; }

  onSubmit(): void {
    this.submitted = true;
    this.dataService.doAnnouncement(null);
    if (this.forgotForm.status !== AppConstants.INVALID_STATUS) {
      this.updateUserCache.emit(this.forgotPasswordOutput);
    }
    // if (this.submitted && !this.form.email.errors && this.validateField()) {
    if (this.submitted && !this.form.email.errors) {
      const participationId = parseInt(this.route.snapshot.paramMap.get("id"));
      // campus microsite 
      let micrositeStoryID = this.userCacheService.getUserData(AppConstants.MICROSITE_STORY_ID);
      const  micrositeId = this.route.snapshot.paramMap.get('storyId') ? this.route.snapshot.paramMap.get('storyId') : null;
      const storyId = micrositeStoryID? micrositeStoryID.toString() : null;
      const req = {
      emailAddress: this.form.email.value,
      participationId,
      micrositeId,
      storyId
     }
      this.saeForgotPasswordService.forgotPass(req).subscribe(data => {
        const response: any = data;
        if (response.status === AppConstants.FAILURE_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.FORGOT_PD_FAILED, message: this.contents.FORGOT_PASS101 });
          this.submitted = false;
        } else if (response.status === AppConstants.SUCCESS_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.FORGOT_PD_SUCCESS, message: this.contents.FORGOT_PASS103 });
          this.forgotForm.reset();
          this.submitted = false;
        }
      }, err => {
        console.log('error occured', err);
      });
    }
  }

   validateEmail() {
        if (!this.forgotForm.value.email
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            this.forgotForm.controls.email.setErrors({ email: true })
            return false;
        }
        return true;
    }

    onClickSendRecoveryEmail() {
         this.submitted = true;
         this.displaySpinner = false;
         let isMfaFactorsResponse: boolean = false;
       if(this.forgotForm.valid && this.validateEmail()) {
        const { email } = this.forgotForm.value;
            this.displaySpinner = true;
            this.dataService.doAnnouncement(null);
            this.saeForgotPasswordService.getSaeUserId(email).subscribe({
                next: (data: any) => {
                    if(data && data.status === AppConstants.SUCCESS && data.token) {
                        this.saeUserId =atob(data.token) || '';
                        if(this.saeUserId === '' || /notfound\-\d+/.test(this.saeUserId)) {
                            this.displaySpinner = false;
                            this.dataService.doAnnouncement({
                                topic: AppConstants.FORGOT_PD_FAILED,
                                message: this.contents?.unableToIdentifyAccount ?? 'We\'re unable to access your account. Please contact Support for assistance.'
                            });
                            return;
                        }
                        // Make the second API call to get Okta MFA factors
                        this.saeForgotPasswordService.getOktaMfaFactors(this.saeUserId).subscribe({
                            next: (mfaData: any) => {
                                 if(mfaData && mfaData.status === AppConstants.SUCCESS) {
                                    console.log('MFA Factors:', mfaData);
                                    isMfaFactorsResponse = true;
                                    this.mfaFactors = mfaData;
                                }else if(mfaData && mfaData.status === AppConstants.FAILURE_STATUS) {
                                    this.displaySpinner = false;
                                    this.dataService.doAnnouncement({ 
                                        topic: AppConstants.FORGOT_PD_FAILED, 
                                        message: this.contents?.unableToIdentifyAccount ?? 'We\'re unable to access your account. Please contact Support for assistance.'
                                    });
                                }

                                // Handle MFA factors response here
                            },
                            error: (mfaError: any) => {
                                this.displaySpinner = false;
                                console.error('Error getting MFA factors:', mfaError);
                                this.dataService.doAnnouncement({ 
                                    topic: AppConstants.FORGOT_PD_FAILED, 
                                    message: 'Exception Occured. Please try again Later.' 
                                });
                            },
                            complete: () => {
                                console.log('Complete callback - isMfaFactorsResponse:', isMfaFactorsResponse);
                                console.log('Complete callback - mfaFactors:', this.mfaFactors);
                                if(isMfaFactorsResponse){
                                    console.log('Navigating to selection page...');
                                    this.router.navigate(['selection'], { 
                                        relativeTo: this.route,
                                        state: { 
                                            mfaFactors: this.mfaFactors,
                                            userId: this.mfaFactors.userId
                                        }
                                    }).then(
                                        (success) => console.log('Navigation successful:', success),
                                        (error) => console.error('Navigation failed:', error)
                                    );
                                }
                                this.displaySpinner = false;
                            }
                        });
                    }else if(data && data.status === AppConstants.FAILURE_STATUS) {
                        this.displaySpinner = false;
                        this.dataService.doAnnouncement({ 
                            topic: AppConstants.FORGOT_PD_FAILED, 
                            message: this.contents?.unableToIdentifyAccount ?? 'We\'re unable to access your account. Please contact Support for assistance.'
                        });
                    }
                },
                error: (error: any) => {
                    this.displaySpinner = false;
                    console.error('Error getting SAE user ID:', error);
                    this.dataService.doAnnouncement({ 
                        topic: AppConstants.FORGOT_PD_FAILED, 
                        message: 'Exception Occured. Please try again Later.' 
                    });
                }
            });
       }
    }
  // validateField() {
  //   let returnVal: boolean = true;
  //   this.emailValidateError = false;
  //   if (!this.isValidEmailAddress(this.form.email.value)) {
  //     this.emailValidateError = true;
  //     returnVal = false;
  //   }
  //   return returnVal;
  // }

  // isValidEmailAddress(email: any): boolean {
  //   let regex = new RegExp('^[\\w-_\\.+]*[\\w-_\\.]\\@([\\w]+\\.)+[\\w]+[\\w]$');
  //   return regex.test(email);
  // }
}
